import { FORM_FIELDS } from './form-fields';

export const FORM_PATHS = {
  LANGUAGE: () => FORM_FIELDS.LANGUAGE,
  HEADLINE: () => FORM_FIELDS.HEADLINE,
  URL: () => FORM_FIELDS.URL,
  PLATFORM: () => FORM_FIELDS.PLATFORM,
  PRODUCT: () => FORM_FIELDS.PRODUCT,
  CLIENT: () => FORM_FIELDS.CLIENT,
  SECTIONS: () => FORM_FIELDS.SECTIONS,
  INTERNAL_INFORMATION: () => FORM_FIELDS.INTERNAL_INFORMATION,
  LIVE_URLS: () =>
    `${FORM_FIELDS.INTERNAL_INFORMATION}.${FORM_FIELDS.LIVE_URLS}`,
  CONTENT_IDS: () =>
    `${FORM_FIELDS.INTERNAL_INFORMATION}.${FORM_FIELDS.CONTENT_IDS}`,
  ARTICLE_VERSION_LIST: () => FORM_FIELDS.ARTICLE_VERSION_LIST,
  NEXT_STATES: () => FORM_FIELDS.NEXT_STATES,
  SURTITLES: () => FORM_FIELDS.SURTITLES,
  TOPICS: () => FORM_FIELDS.TOPICS,
  TOPICS_WITH_TRANSLATIONS: () => FORM_FIELDS.TOPICS_WITH_TRANSLATIONS,
  TAGS: () => FORM_FIELDS.TAGS,
  COMPANIES: () => FORM_FIELDS.COMPANIES,
  PEOPLE: () => FORM_FIELDS.PEOPLE,
  PUBLISH_TIME: () => `${FORM_FIELDS.PUBLISH}.${FORM_FIELDS.DATE}`,
  TIMEZONE: () => `${FORM_FIELDS.PUBLISH}.${FORM_FIELDS.TIMEZONE}`,
  SHOW_PUBLISH_TIME: () =>
    `${FORM_FIELDS.PUBLISH}.${FORM_FIELDS.SHOW_PUBLISH_TIME}`,
  SELECTED_AUTHORS: () => FORM_FIELDS.SELECTED_AUTHORS,
  RELATED_MANAGERS: () => FORM_FIELDS.RELATED_MANAGERS,
  RELATED_FUNDS: () => FORM_FIELDS.RELATED_FUNDS,
  RELATED_SECTORS: () => FORM_FIELDS.RELATED_SECTORS,
  RELATED_ASSET_CLASSES: () => FORM_FIELDS.RELATED_ASSET_CLASSES,
  RELATED_ETFS: () => FORM_FIELDS.RELATED_ETFS,
  RELATED_INVESTMENT_TRUSTS: () => FORM_FIELDS.RELATED_INVESTMENT_TRUSTS,
  RELATED_SHARES: () => FORM_FIELDS.RELATED_SHARES,
};
